/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archiveconfirmmessage2Inputs */



/**
* | output |
* | --- |
* | "The contact will move to the “Archive” tab, from where you can bring them back to the main list." |
*
* @param {Archiveconfirmmessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const archiveconfirmmessage2 = /** @type {((inputs?: Archiveconfirmmessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archiveconfirmmessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The contact will move to the “Archive” tab, from where you can bring them back to the main list.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El contacto pasará a la pestaña «Archivo», desde donde puedes devolverlo a la lista principal.")
	return /** @type {LocalizedString} */ ("Контакт попадет на вкладку “Архив”, откуда его можно вернуть на главную.")
});
export { archiveconfirmmessage2 as "archiveConfirmMessage" }